import { render, staticRenderFns } from "./company-search-autocomplete.vue?vue&type=template&id=200c1028&scoped=true&"
import script from "./company-search-autocomplete.vue?vue&type=script&lang=js&"
export * from "./company-search-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./company-search-autocomplete.vue?vue&type=style&index=0&id=200c1028&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200c1028",
  null
  
)

export default component.exports